import React from 'react';

import PropTypes from 'prop-types';
import { faFilter } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { filterShape } from '../../types';
import FilterMenu from './FilterMenu';

const FilterButton = ({ activeFilters, clearFilters, filters }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline">
        <FontAwesomeIcon icon={faFilter} />
        <span>Filter</span>
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="start">
      <FilterMenu
        activeFilters={activeFilters}
        clearFilters={clearFilters}
        filters={filters}
      />
    </DropdownMenuContent>
  </DropdownMenu>
);

FilterButton.propTypes = {
  activeFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  clearFilters: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(filterShape).isRequired,
};

export default FilterButton;
